module.exports = __webpack_public_path__ + "img/intensityReport.350b0eee.svg";